
/* eslint-disable no-unused-vars */

import { forwardRef, memo, useMemo } from 'react'
import './style.css'
import React from 'react'

import {  NavLink } from 'react-router-dom'
import courseData from '../../courses'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'


const Course = memo(
  // eslint-disable-next-line react/prop-types
  forwardRef(({ course }, ref) => {
    const projectListCopy = useMemo(() => {
      return JSON.parse(JSON.stringify(courseData?.projectList ?? []))
    }, [courseData?.projectList])
    
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.substring(1)
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location])
    return (
      <section className="main center" id='courses' ref={ref}>
        <h2 className="main-title">
          <span className="yellow-span">ОБРАЗОВАТЕЛЬНЫЕ</span> ПРОГРАММЫ
        </h2>

        <ul className="main-box">
          {projectListCopy.map((item) => (
            <li className="main-box-cur" key={item.slug}>
              <NavLink to={`/projects/${item.slug}`}>
                <div className="main-img">
                  <img
                    className="main-img-orig"
                    src={item.src}
                    alt={item.alt}
                  />
                  <p className="main-box-text" >{item.alt}</p>
                </div>
              </NavLink>
            </li>
          ))}
        </ul>

       
      </section>
    )
  }),
)

export default Course
